import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Scheduling/hooks/useScheduleConfig.ts
function useScheduleConfig(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Scheduling.GetScheduleConfig.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire
	});
	return {
		data: data?.scheduleConfig,
		loading: isCalling,
		refresh: call
	};
}
export { useScheduleConfig };

//# sourceMappingURL=useScheduleConfig.js.map